import { FC } from 'react';

import Box from '@mui/material/Box/Box';
import List from '@mui/material/List/List';

import { ListSectionListItem, ListSectionTitle } from './ListSection.styles';

import { IListSection } from 'types/articles';

import { colors } from 'styles';

export const ListSection: FC<IListSection> = ({ listItems, title, text }) => {
  return (
    <Box>
      <ListSectionTitle>{title}</ListSectionTitle>

      <List style={{ padding: 0 }}>
        {listItems.map((item) => (
          <ListSectionListItem key={item}>●&nbsp;&nbsp;&nbsp;&nbsp;{item}</ListSectionListItem>
        ))}
      </List>

      {text && (
        <div
          style={{
            fontSize: '18px',
            lineHeight: '140%',
            color: colors.textPrimary,
            marginTop: '16px',
          }}
        >
          {text}
        </div>
      )}
    </Box>
  );
};
